import React from 'react';

interface ICartDeliveryTypeRadios {
  deliveryMode: string;
  setDeliveryMode: (value: string) => void;
}

function CartDeliveryTypeRadios({
  deliveryMode,
  setDeliveryMode,
}: ICartDeliveryTypeRadios) {
  const options = [
    { value: 'delivery', label: 'Доставка' },
    { value: 'self-delivery', label: 'Самовывоз' },
  ];

  return (
    <div className="flex gap-7 mt-4">
      {options.map((option) => (
        <label
          key={option.value}
          className="flex items-center gap-2 cursor-pointer"
        >
          <input
            type="radio"
            name="deliveryMode"
            value={option.value}
            checked={deliveryMode === option.value}
            onChange={(e) => setDeliveryMode(e.target.value)}
            className="w-4 h-4 accent-red-600  cursor-pointer"
          />
          <span className="text-sm font-medium text-gray-700">
            {option.label}
          </span>
        </label>
      ))}
    </div>
  );
}

export default CartDeliveryTypeRadios;
